var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout-landing" }, [
    _c(
      "div",
      { staticClass: "layout-landing__content" },
      [_vm._t("content")],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "layout-landing__illustration" },
      [_vm._t("illustration")],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }